import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import { apolloReducer } from 'apollo-cache-redux';
import fuse from './fuse';
import ui from './ui.reducer';
import channel from './channel.reducer';
import sidebar from './sidebar.reducer';
import activity from './activity.reducer';
import subscriptions from './subscriptions';
import auth from '../../auth/store/reducers';
import favoritesFilter from './favoritesFilter';
import notifications from './notifications.reducers';
import searchVideos from './searchVideos.reducer';
import layoutSidebar from './layoutSidebar.reducer';
import trackListExpanded from './trackslist.reducer';
import translation from '../../translation/store/reducers';
var rootReducer = combineReducers({
    apollo: apolloReducer,
    form: form,
    ui: ui,
    auth: auth,
    fuse: fuse,
    channel: channel,
    sidebar: sidebar,
    activity: activity,
    translation: translation,
    searchVideos: searchVideos,
    notifications: notifications,
    layoutSidebar: layoutSidebar,
    subscriptions: subscriptions,
    favoritesFilter: favoritesFilter,
    trackListExpanded: trackListExpanded,
});
export default rootReducer;



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/index.ts
// module id = 979
// module chunks = 81